<template>
  <div class="step-section">
    <h2>Step Two: What are your details?</h2>
    <p>Enter your details below. These will be printed onto the pathology forms.</p>

    <div class="details-section">
      <span>First name: </span>
      <input type="text" @input="updateUserDetails" ref="firstName">
    </div>

    <div class="details-section">
      <span>Last name: </span>
      <input type="text" @input="updateUserDetails" ref="lastName">
    </div>

    <div class="details-section">
      <span>Provider number: </span>
      <input type="text" @input="updateUserDetails" ref="providerNumber">
    </div>

    <div class="details-section">
      <span>Consultant name: </span>
      <input type="text" @input="updateUserDetails" ref="consultantName">
    </div>

    <div class="details-section">
      <span>Auslab code: </span>
      <input type="text" @input="updateUserDetails" ref="auslabCode">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StepTwo',
    components: {},
    data() {
      return {
    	}
    },
    methods: {
      updateUserDetails() {
        var userDetails = {
          firstName: this.$refs.firstName.value,
          lastName: this.$refs.lastName.value,
          providerNumber: this.$refs.providerNumber.value,
          consultantName: this.$refs.consultantName.value,
          auslabCode: this.$refs.auslabCode.value,
        }
        this.$emit('update:userDetails', userDetails)
      }
    }
  }
</script>

<style>
  .details-section {
    width: 300px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
</style>
